var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.29248,
    y: 0.426758,
    width: 24.5854,
    height: 24.5854,
    rx: 12.2927,
    fill: "#303746"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_436_1216",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 19,
    height: 19
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.36572,
    y: 3.49976,
    width: 18.439,
    height: 18.439,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_436_1216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5097 16.2537L16.9261 10.8372L15.8505 9.76162L11.5097 14.1025L9.32003 11.9128L8.24442 12.9885L11.5097 16.2537ZM12.5853 20.4025C11.5225 20.4025 10.5237 20.2007 9.58893 19.7971C8.65417 19.394 7.84106 18.8467 7.1496 18.1552C6.45814 17.4638 5.91086 16.6506 5.50776 15.7159C5.10415 14.7811 4.90234 13.7824 4.90234 12.7195C4.90234 11.6567 5.10415 10.658 5.50776 9.72321C5.91086 8.78845 6.45814 7.97534 7.1496 7.28388C7.84106 6.59241 8.65417 6.04488 9.58893 5.64127C10.5237 5.23817 11.5225 5.03662 12.5853 5.03662C13.6481 5.03662 14.6469 5.23817 15.5816 5.64127C16.5164 6.04488 17.3295 6.59241 18.0209 7.28388C18.7124 7.97534 19.2597 8.78845 19.6628 9.72321C20.0664 10.658 20.2682 11.6567 20.2682 12.7195C20.2682 13.7824 20.0664 14.7811 19.6628 15.7159C19.2597 16.6506 18.7124 17.4638 18.0209 18.1552C17.3295 18.8467 16.5164 19.394 15.5816 19.7971C14.6469 20.2007 13.6481 20.4025 12.5853 20.4025Z",
    fill: "#00DF80"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadicon);
export default __webpack_public_path__ + "static/media/upload icon.69fcd0c3721e32c616a08fab6142f22d.svg";
export { ForwardRef as ReactComponent };